import { Title } from "@mantine/core";
import type { Control } from "react-hook-form";
import { FormFieldController } from "../../../../../../../components/BuildingBlocks/Forms/Controllers/FormFieldController";
import { isValidDeIban } from "../../../../../../../utils/validation/isValidDeIban";
import { isValidZipCode } from "../../../../../../../utils/validation/isValidZipCode";
import type {
  Paragraph6CompanyResponse,
  Paragraph6ContractFormFields,
  Paragraph6ContractResponse
} from "../../../../../Paragraph6.types";
import { PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA } from "../Paragraph6ContractForm.constants";

interface GeneralInformationProps {
  control: Control<Paragraph6ContractFormFields>;
  paragraph6Contract?: Partial<Paragraph6ContractResponse>;
  paragraph6Companies: Array<Paragraph6CompanyResponse>;
}

function GeneralInformation({
  control,
  paragraph6Companies,
  paragraph6Contract
}: GeneralInformationProps) {
  const supplierChoices: Array<{ value: number; label: string }> =
    paragraph6Companies
      ?.filter((company) => company.id !== undefined)
      .map((company) => ({
        value: company.id,
        label: company.name
      })) || [];
  const supplierFieldInfo = {
    ...PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.supplier,
    data: supplierChoices,
    disabled:
      paragraph6Contract?.gemeinde_anteile_erzeuger &&
      paragraph6Contract?.gemeinde_anteile_erzeuger.length > 0
  };

  return (
    <>
      <section>
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.name}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.project_description}
        />
        <FormFieldController control={control} data={supplierFieldInfo} />
      </section>

      <section>
        <Title mt="lg" order={6}>
          Gemeinde/Kommune
        </Title>
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_name}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_name_extra}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_address}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_address_extra}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_city}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_zip}
          rules={{
            validate: (value) => {
              return isValidZipCode(value || "");
            }
          }}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_phone}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_email}
        />
        <FormFieldController
          control={control}
          data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.community_iban}
          rules={{
            validate: (value) => {
              return isValidDeIban(value || "");
            }
          }}
        />
        <FormFieldController
          control={control}
          data={
            PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.sepa_remittance_information
          }
        />
      </section>
    </>
  );
}

export { GeneralInformation };
